<template>
  <a-select
    v-model:value="currentLocale"
    size="small"
    style="width: 100px"
    @change="handleLanguageChange"
  >
    <a-select-option value="en">English</a-select-option>
    <a-select-option value="zh">中文</a-select-option>
  </a-select>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const currentLocale = ref<string>(locale.value as string)

// 从 localStorage 读取保存的语言设置，如果没有则使用当前 locale
onMounted(() => {
  const savedLocale = localStorage.getItem('ui-locale')
  if (savedLocale && (savedLocale === 'en' || savedLocale === 'zh')) {
    currentLocale.value = savedLocale
    locale.value = savedLocale
  } else {
    // 如果没有保存的设置，使用当前 locale 并保存
    const currentLang = locale.value as string
    if (currentLang === 'en' || currentLang === 'zh') {
      currentLocale.value = currentLang
      localStorage.setItem('ui-locale', currentLang)
    }
  }
})

// 切换语言
const handleLanguageChange = (value: string) => {
  locale.value = value
  localStorage.setItem('ui-locale', value)
}
</script>

